import { useCallback } from 'react';
/**
 * A click handler which calls a function and calls it again
 * once the user's mouse leaves the element
 */
export function useOnClickTempToggle(options) {
  const {
    callback,
    offCallback = callback,
    ref
  } = options;
  return useCallback(({
    target
  }) => {
    ref.current = target;
    callback();
    target.addEventListener('mouseleave', offCallback, {
      once: true
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [callback, offCallback]);
}